import { render, staticRenderFns } from "./EqifyMenuDropdown.vue?vue&type=template&id=379b548c"
import script from "./EqifyMenuDropdown.vue?vue&type=script&lang=ts"
export * from "./EqifyMenuDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports